import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import OurServices from "@/components/OurServices";
import WhyMumzo from "@/components/WhyMumzo";
import FoundingBeta from "@/components/FoundingBeta";
import LaunchCity from "@/components/LaunchCity";
import WaitlistSection from "@/components/WaitlistSection";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="mumzo-landing" className="relative bg-background">
      <Nav />
      <Hero />
      <WhyMumzo />
      <OurServices />
      <FoundingBeta />
      <LaunchCity />
      <WaitlistSection />
      <Footer />
    </main>
  );
}
